import React from "react";
import PropTypes from "prop-types";

const InfoCircleIcon = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  ...props
}) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M1.66699 10.0003C1.66699 14.5996 5.40103 18.3337 10.0003 18.3337C14.5996 18.3337 18.3337 14.5996 18.3337 10.0003C18.3337 5.40103 14.5996 1.66699 10.0003 1.66699C5.40103 1.66699 1.66699 5.40103 1.66699 10.0003V10.0003"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3333V10"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.66699H10.0083"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

InfoCircleIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

InfoCircleIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "#E17100",
  strokeWidth: 1.66667,
  className: "",
};

export default InfoCircleIcon;
